// import components
import { styled, ListItemText, ListItemIcon, ListItem } from '@mui/material';

export const StyledShortcutsRowListItemText = styled(ListItemText)(() => ({
  width: '280px',
  textWrap: 'pretty'
}));

export const StyledShortcutsRowListItemIcon = styled(ListItemIcon)(() => ({
  minWidth: 'auto'
}));

export const StyledShortcutsRowListItem = styled(ListItem)(({ theme }) => ({
  '&:nth-child(even)': {
    backgroundColor: theme.palette.grey[50],
    borderRadius: theme.spacing(2)
  }
}));
